/* eslint-disable import/no-anonymous-default-export */
import React from 'react'
import { Box, CircularProgress } from '@material-ui/core'
import clsx from 'clsx'
import { makeStyles } from '@material-ui/core'


const useStyles = makeStyles({
  boxRoot: {
    position: 'relative',
  },
  inline: {
    display: 'inline-block',
  },
  loadingRoot: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: props => -(props.size ? props.size / 2 : 12),
    marginLeft: props => -(props.size ? props.size / 2 : 12),
  },
  wrapper: {
    position: 'absolute',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    backgroundColor: "rgba(255, 255, 255, .6)"
  }
})

export default props => {
  const { children, loading, inline, size = 24 } = props
  const classes = useStyles()
  return (
    <Box className={clsx([inline && classes.inline, classes.boxRoot])}>
      {children}
      {loading && (
        <>
          <div className={classes.wrapper} />
          <CircularProgress size={size} className={classes.loadingRoot} disableShrink />
        </>
      )}
    </Box>
  )
}
